export default __webpack_public_path__ + "static/media/vscode.31b27251.svg";